/**
 * Clipboard Utility Functions
 *
 * Shared utilities for clipboard category styling and labels.
 * Used across ClipboardPage and EpisodePage for consistent styling.
 */

export type ClipboardCategory = 'users' | 'pfy' | 'management' | 'technical';

/**
 * Returns Tailwind CSS classes for category badge styling
 * @param category - The clipboard note category
 * @returns Tailwind CSS class string for badge styling
 */
export const getCategoryBadgeColor = (category: ClipboardCategory | 'all'): string => {
  switch (category) {
    case 'users':
      return 'bg-red-500/20 text-red-400 border-red-500/50';
    case 'pfy':
      return 'bg-teal-500/20 text-teal-400 border-teal-500/50';
    case 'management':
      return 'bg-amber-500/20 text-amber-400 border-amber-500/50';
    case 'technical':
      return 'bg-purple-500/20 text-purple-400 border-purple-500/50';
    default:
      return 'bg-gray-500/20 text-gray-400 border-gray-500/50';
  }
};

/**
 * Returns human-readable label for category
 * @param category - The clipboard note category
 * @returns Human-readable category label
 */
export const getCategoryLabel = (category: ClipboardCategory | 'all'): string => {
  switch (category) {
    case 'users':
      return 'User Observations';
    case 'pfy':
      return 'PFY Training';
    case 'management':
      return 'Management';
    case 'technical':
      return 'Technical Wisdom';
    default:
      return 'All';
  }
};
